import Vue from 'vue'
import LoginNotification from './components/LoginNotification'
import hybrid from "@general/utils/appHybrid";
import {isLoggedIn} from './index'

let loginNotificationObj;

const showLoginNotification = () => {
  if (window.nativeAppOpen) {
    return hybrid.call('showAuthentication', {tier: 'light'})
  }
  if (!loginNotificationObj) {
    const el = document.createElement('div')
    document.body.appendChild(el)

    loginNotificationObj = new Vue(LoginNotification)
    loginNotificationObj.$mount(el)
  }

  loginNotificationObj.visible = true
}

const guard = (callback, event) => {
  if (isLoggedIn()) {
    callback(event)
  } else {
    showLoginNotification()
  }
}

const withUserRequired = (component) => {
  return Vue.component(`${component}WithUserRequired`, {
    render(createElement) {
      let listeners = {}
      for (const [key, callback] of Object.entries(this.$listeners)) {
        listeners[key] = (e) => guard(callback, e)
      }

      return createElement(component, {on: listeners}, this.$slots.default)
    }
  })
}

export default withUserRequired